import { FragmentStore } from '../runtime/stores/fragment'
import artifact from '$houdini/artifacts/InventoryOptionDataForConfig'


// create the fragment store

export class InventoryOptionDataForConfigStore extends FragmentStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryOptionDataForConfigStore",
			variables: true,
			
		})
	}
}
